// extracted by mini-css-extract-plugin
module.exports = {"section":"conheca_section__5jJuJ","text":"conheca_text__1rMi8","image":"conheca_image__MHP7f"};